module.exports = __webpack_public_path__ + "img/Charisma.6d3c540e.png";